import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=6067fd37&scoped=true"
import script from "./RootNode.vue?vue&type=script&lang=js"
export * from "./RootNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067fd37",
  null
  
)

export default component.exports